<section class="reminderUserPicker">
  <div class="reminderUserPicker__user">
    @if (allUsers[ppTargetUserId()]?.avatarPublicUrl) {
      <img
        ppTooltip
        ppImage
        class="assignees__avatar"
        [src]="allUsers[ppTargetUserId()]?.avatarPublicUrl"
        [ppTitle]="allUsers[ppTargetUserId()]?.userName"
      />
    }

    @if (!allUsers[ppTargetUserId()]?.avatarPublicUrl && allUsers[ppTargetUserId()]) {
      <img
        ppTooltip
        class="assignees__avatar"
        [src]="EIconPath.PLACEHOLDER_USER"
        [ppTitle]="allUsers[ppTargetUserId()]?.userName"
      />
    }
  </div>

  @if (assignees.length || ppEditable()) {
    <span class="reminderUserPicker__line"></span>
  }

  @for (userId of assignees; track userId; let index = $index) {
    @if (ppTargetUserId() !== userId && index < 3) {
      <div class="reminderUserPicker__user">
        @if (allUsers[userId]?.avatarPublicUrl) {
          <img
            ppTooltip
            ppImage
            class="assignees__avatar"
            [src]="allUsers[userId]?.avatarPublicUrl"
            [ppTitle]="allUsers[userId]?.userName"
          />
        }
        @if (!allUsers[userId]?.avatarPublicUrl && allUsers[userId]) {
          <img
            ppTooltip
            class="assignees__avatar"
            [src]="EIconPath.PLACEHOLDER_USER"
            [ppTitle]="allUsers[userId]?.userName"
          />
        }
        @if (ppEditable() && !ppGuestUser()) {
          <button class="reminderUserPicker__removeButton" (click)="selectUser(userId)">
            <pp-icon
              [ppSrc]="EIconPath.ICON_NAV_CLOSE_14"
              ppClass="setSize14"
              ppColor="grey-900"
            ></pp-icon>
          </button>
        }
      </div>
    }
  }

  @if (assignees.length > 3) {
    <div class="reminderUserPicker__plus" ppTooltip [ppTitle]="tooltipText" [ppSanitize]="false">
      + {{ assignees.length - 3 }}
    </div>
  }

  @if (ppEditable()) {
    <button
      class="reminderUserPicker__button"
      [class.reminderUserPicker__button--disabled]="!ppPointId() || ppGuestUser()"
      [id]="buttonId"
      (click)="showUsersDropdown()"
      ppTooltip
      [ppTitle]="
        ppPointId()
          ? ppGuestUser()
            ? ('reminder_user_picker_permission_denied_warning' | ppTranslate)
            : ''
          : ('reminder_user_picker_no_point_warning' | ppTranslate)
      "
    >
      <pp-icon
        [ppSrc]="EIconPath.ICON_INPUT_PLUS_32"
        [ppColor]="
          dropdown?.visible && dropdown?.buttonId === buttonId ? 'primary-600' : 'grey-400'
        "
        [ppHoverColor]="
          dropdown?.visible && dropdown?.buttonId === buttonId
            ? 'primary-600'
            : ppEditable() && !ppGuestUser() && ppPointId()
              ? 'grey-600'
              : 'grey-400'
        "
        data-test="addReminderUserButtom"
      ></pp-icon>
    </button>
  }
</section>
